import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Quotation } from 'src/app/shared/models/quotation.model';
import { NumericUpDownComponent } from 'src/app/ui/molecules/numeric-up-down/numeric-up-down.component';

@Component({
  selector: 'app-step4',
  standalone: true,
  imports: [
    TranslatePipe,
    NumericUpDownComponent
  ],
  templateUrl: './step4.component.html',
  styleUrl: './step4.component.scss'
})
export class Step4Component {
  @Input({required: true}) quotation: Quotation;
}
